import React from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import constants from "../../constants/tutorialAutomaton";
import constantsPathSimulation from "../../constants/PathSimulation/pathSimulationConstants";
import { useUser } from "../../context/userContext";
import { useDot } from "../../context/automatonContext";
import DOT from "../../components/MachineElement/DOT";
import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHistorical";
import "./classes.css";
import { Button, Input } from "@material-ui/core";
import DataService from "services/DataService";
import Loading from "components/Loading/loading";
import simulation from "../../views/Simulate/formatList";
import validations from "../../utils/validationsMachine";
import { useAlert } from "../../context/Feedback/alertContext";
import { translateBackendError } from "utils/backEndErrorTranslator";

import { formatPath } from "utils/formatPath";
import { isNullOrUndefinedOrEmptyString } from "../../utils/generalValidators";
import { MACHINE_TYPES } from "../../variables/machineVariables";

const useStyles = makeStyles(styles);

export default function SimulateAutomataWordDialog() {
  const { setAlert } = useAlert();
  const { language, credential } = useUser();
  const {
    isActiveDialogSimulate,
    setActiveDialogSimulate,
    machineStates,
    machineTransitions,
    setResponseSimulate,
    setDataTreeDerivation,
    setSimulationPath,
    setSimulationIndex,
    setIsSimulating,
    setIsMultiPathSimulating, // Adicionado para multi-caminho
    setCurrentComputationLevel, // Adicionado para multi-caminho
    automatonType,
  } = useDot();
  const history = useHistory();
  const [checked, setChecked] = useState(true);
  const [word, setWord] = useState("");
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  const handleClose = () => {
    setActiveDialogSimulate(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const toDOTLanguage = () => {
    let dot = new DOT(machineStates, machineTransitions);

    dot.toDotLanguage();

    let string = dot.toString();

    return string;
  };

  const handleSubmitWord = async () => {
    if (!isNullOrUndefinedOrEmptyString(word)) {
      try {
        setLoading(true);
        let dot = toDOTLanguage();
        if (validations.isValidMachine(dot).valid) {
          const config = {
            headers: {
              Authorization: credential,
            },
          };

          let response;
          let wordToSend = word;

          if (automatonType === MACHINE_TYPES.AP) {
            response = await DataService.checkPDAWord(
              dot,
              wordToSend,
              "DEFAULT",
              config
            );
          } else if (automatonType === MACHINE_TYPES.ALL) {
            if (wordToSend.startsWith("<") && wordToSend.endsWith(">")) {
              wordToSend = wordToSend.substring(1, wordToSend.length - 1);
            }
            response = await DataService.checkLBAWord(dot, wordToSend, config);
          } else if (automatonType === MACHINE_TYPES.MT) {
            if (wordToSend.startsWith("B") && wordToSend.endsWith("B")) {
              wordToSend = wordToSend.substring(1, wordToSend.length - 1);
            }
            response = await DataService.checkTMWord(dot, wordToSend, config);
          } else {
            response = await DataService.checkWord(dot, wordToSend, config);
          }
          if (isMounted) {
            const {
              tape,
              wordTape,
              finalStates,
              initialState,
              isAccept,
              symbolsExternFromAlphabet,
              computationInterrupted,
            } = response.data;

            if (computationInterrupted && isMounted) {
              setAlert({
                active: true,
                text: constantsPathSimulation.errorMessages
                  .computationInterrupted[language],
                color: "warning",
                sevarity: "warning",
                duration: 5000,
              });
            }

            const sortedTape = tape
              ? [...tape].sort((a, b) => a.stepId - b.stepId)
              : [];

            // 1. Salva o resultado final
            setResponseSimulate({
              responseSimulateAutomata: {
                word: wordTape,
                tape: sortedTape,
                finalStates: finalStates,
                initialState,
                isAccept: isAccept,
                symbolsExternFromAlphabet: symbolsExternFromAlphabet,
                computationInterrupted: computationInterrupted,
              },
            });

            // 2. Prepara os dados para a visualização da árvore de derivação
            const dataTreeDerivation = simulation.formatList(sortedTape);
            setDataTreeDerivation(dataTreeDerivation);

            let isAFD = false;

            if (
              automatonType !== MACHINE_TYPES.AP &&
              automatonType !== MACHINE_TYPES.ALL &&
              automatonType !== MACHINE_TYPES.MT
            ) {
              const isAFDResponse = await DataService.seeIfAFDAutomaton(
                dot,
                config
              );
              isAFD = isAFDResponse.data;
            }

            if (tape && tape.length > 0) {
              if (!isAFD) {
                setIsSimulating(false);
                setSimulationPath([]);
                setSimulationIndex(0);

                setIsMultiPathSimulating(true);
                setCurrentComputationLevel(0);

                history.push("/user/automaton");
              } else {
                setIsMultiPathSimulating(false);
                setCurrentComputationLevel(0);

                const linearPath = formatPath(tape, isAccept, finalStates);
                const statePath = linearPath.map(
                  (step) => step.actualState.name
                );

                setResponseSimulate((prev) => ({
                  ...prev,
                  responseSimulateAutomata: {
                    ...prev.responseSimulateAutomata,
                    tape: linearPath,
                    word: wordTape,
                  },
                }));

                setIsSimulating(true);
                setSimulationPath(statePath);
                setSimulationIndex(0);

                history.push("/user/automaton");
              }
            } else {
              history.push("/user/responseAutomaton");
            }
            setWord("");
          }
        } else {
          if (isMounted) {
            setAlert({
              active: true,
              text: constants.alerts.automatonError[language],
              color: "info",
              sevarity: "info",
            });
            history.push("/user/automaton");
          }
        }
      } catch (e) {
        console.error(e);
        if (isMounted) {
          let alertConfig = {
            text: constantsPathSimulation.errorMessages.simulationError[
              language
            ],
            color: "danger",
            sevarity: "error",
            duration: 2000,
          };

          if (e.response) {
            if (e.response.status === 422) {
              const messageFromBackend =
                e.response.data && e.response.data.message;
              alertConfig = {
                text:
                  messageFromBackend ||
                  constantsPathSimulation.errorMessages.manyRulesInSimulation[
                    language
                  ],
                color: "warning",
                sevarity: "warning",
                duration: 4000,
              };
            } else if (e.response.status === 400) {
              const messageFromBackend =
                e.response.data && e.response.data.message;
              alertConfig = {
                text: translateBackendError(messageFromBackend, language),
                color: "warning",
                sevarity: "warning",
                duration: 5000,
              };
            } else if (e.response.data && e.response.data.message) {
              alertConfig.text = e.response.data.message;
            }
          }

          setAlert({
            active: true,
            text: alertConfig.text,
            color: alertConfig.color,
            sevarity: alertConfig.sevarity,
            duration: alertConfig.duration,
          });

          history.push("/user/automaton");
        }
      }

      if (isMounted) {
        setActiveDialogSimulate(false);
        setLoading(false);
      }
    } else {
      if (isMounted) {
        setAlert({
          active: true,
          text: constants.alerts.missRegex[language],
          color: "info",
          sevarity: "info",
        });
      }
    }
  };

  return (
    <div>
      <Loading loading={loading} />
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveDialogSimulate}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {constants.modal.simulateAutomata[language]}

            <div className="wrapper-button-close button-margin">
              <Button
                style={{
                  backgroundColor: "#999",
                  color: "#FFF",
                  width: "10px",
                }}
                onClick={handleClose}
              >
                X
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Input
            className={classes.input}
            placeholder="Palavra"
            value={word}
            fullWidth
            onChange={(e) => setWord(e.target.value)}
            id="word-input"
            name="wordInput"
            autoComplete="off"
            onKeyUp={(e) => {
              const ENTER = 13;
              if (e.keyCode === ENTER) {
                handleSubmitWord();
              }
            }}
          />
        </DialogContent>
        <DialogActions className={classes.dialog}>
          <Button
            onClick={() => {
              handleSubmitWord();
            }}
          >
            ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
